import React from 'react';

const Index = () => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M11.99 0L0 8.723V24H24V8.723L11.99 0ZM11.9909 2.47205L21.7839 9.58505L15.0489 14.173L11.9999 11.703L8.95087 14.174L2.21387 9.58505L11.9909 2.47205ZM7.329 15.488L2 11.858V19.806L7.329 15.488ZM2.47363 22L11.9996 14.277L21.5256 22H2.47363ZM16.6709 15.489L21.9999 19.806V11.858L16.6709 15.489Z" fill="#333333"/>
      </svg>
    </>
  );
};

export default Index;